import React, { useEffect } from "react";
import ScratcherBProps from "./ScratcherBProps";
import { useSelector } from "react-redux";
import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import styles from "./ScratcherB.module.scss";

const ScratcherB: React.FC<ScratcherBProps> = (props) => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);
    const settings = useSelector((state) => state.settings.content);

    const { scratcherDataToken, scratcherDataId, scratcherDataType, scriptSrcString } = props.content;

    useEffect(() => {
        const scriptId = "scratcher-embed-script";

        // Clean up existing
        const oldScript = document.getElementById(scriptId);
        if (oldScript) oldScript.remove();

        const script = document.createElement("script");
        script.id = scriptId;
        script.src = scriptSrcString;
        script.defer = true;

        script.setAttribute("data-token", scratcherDataToken);
        script.setAttribute("data-id", scratcherDataId);
        script.setAttribute("data-type", scratcherDataType);

        script.onload = () => console.log("Scratcher script loaded!");
        script.onerror = () => console.error("Scratcher script failed to load");

        const container = document.getElementById("scratcher-container");
        if (container) {
            container.innerHTML = "";
            container.appendChild(script);
        } else {
            console.error("Scratcher container not found");
        }

        return () => {
            const cleanup = document.getElementById(scriptId);
            if (cleanup) cleanup.remove();
        };
    }, [scratcherDataToken, scratcherDataId, scratcherDataType, scriptSrcString]);

    return (
        <section
            className={combineClasses(styles.wrapper, ...wrapperClasses)}
            style={wrapperStyles}
        >
            <div
                id="scratcher-container"
                className={styles.container}
            ></div>
        </section>
    );
};

export default ScratcherB;
